<script setup>

    import StaticWidget from "@/components/common/other/StaticWidget"
    import Shipments from "@/components/shipments/Shipments"
    import SlideInDrawer from "@/components/common/navigation/SlideInDrawer";
    import ShipmentDocumentDownload from "@/components/shipments/ShipmentDocumentDownload";

    import { useStore } from 'vuex';
    import { inject, onMounted, ref } from 'vue'
    import Button from "@/components/common/input/Button.vue";
    import Table from "@/components/common/other/Table.vue";
    import API from "@/classes/global/API";
    import { useGetDocumentsList } from "@/composables/common/useGetDocumentsList";

    const shipments = inject("shipments");
    const store = useStore();
    const renderNewShipments = ref(true);

    let tabDataModelReady = ref(false);

    onMounted(() => {

        mapTabSelections()
    })

    function mapTabSelections() {

        shipments.value.activeShipmentTabs.air.active = store.state.userSettings.showShipmentsTabSettings.air;
        shipments.value.activeShipmentTabs.road.active = store.state.userSettings.showShipmentsTabSettings.road;
        shipments.value.activeShipmentTabs.sea.active = store.state.userSettings.showShipmentsTabSettings.sea;
        shipments.value.activeShipmentTabs.rail.active = store.state.userSettings.showShipmentsTabSettings.rail;
        shipments.value.activeShipmentTabs.courier.active = store.state.userSettings.showShipmentsTabSettings.courier;
        shipments.value.activeShipmentTabs.other.active = store.state.userSettings.showShipmentsTabSettings.other;

        tabDataModelReady.value = true;

    }

    async function searchSelectedConsolJob(rowData) {


        if (!rowData.shipmentNumber) {
            //Temp Patch for client
            shipments.value.shipmentsSearchTerm = rowData.reference;
        }
        else {

            shipments.value.shipmentsSearchTerm = rowData.shipmentNumber;

        }

       
        renderNewShipments.value = !renderNewShipments.value;
        // TODO This full view needs a better way of displaying the job data as we are using the re render to search
        // TODO by the job number, this may give other results if data matches in any way.
        // shipments.value.selectedShowShipmentsTab = rowData.mode;
    }

</script>

<template id="cmp-show-shipments" class="view-show-shipments">

  <SlideInDrawer
      :height="300"
      :width="1100"
      title="Consolidated Jobs"
      v-model:open-drawer="shipments.openConsolDrawer">
    <div style="margin-bottom: 10px">&#128203; Jobs Under
      <span
          style="color: var(--aqua-blue-definition); font-weight: bold">{{ shipments.currentSelectedConsolJob.shipmentNumber }}</span>
    </div>
    <Table
        :key="shipments.consolGridData.length"
        height="160"
        :page-size="200"
        :selectable="false"
        :allow-column-resize="true"
        :row-selection="false"
        :highlight-rows="false"
        :columns="shipments.consolGridColumns"
        :dataSource="shipments.consolGridData">
      <template v-slot:selectRow="row">
        <Button
            data-cy="btnViewShipment"
            @click="searchSelectedConsolJob(row.grid)"
            title="View In Main Grid"
            style="height:24px"
            type="toolbar"
            text="Full View">
        </Button>
      </template>
      <template v-slot:documents="row">
        <div
            v-if="row.grid.documents"
            title="View Documents"
            @click="useGetDocumentsList(row.grid.id, null, store, shipments)"
            class="grid-docs-icon">&#128194
        </div>
      </template>
    </Table>
  </SlideInDrawer>
  <SlideInDrawer
      :height="218"
      title="Available Documents"
      v-model:open-drawer="shipments.shipmentDocsDrawer">
    <template #icon><i class="fa-solid fa-folder-open" style="color: #eab410;"></i></template>
    <ShipmentDocumentDownload
        v-model="shipments">
    </ShipmentDocumentDownload>
  </SlideInDrawer>
  <StaticWidget
      height="735"
      title="Shipments For All Modes">
    <Shipments v-if="tabDataModelReady" :key="renderNewShipments"></Shipments>
  </StaticWidget>
</template>

<style lang="scss" scoped>

</style>
